import { CloseButton, Drawer, Flex, Stack, Text } from "@mantine/core";

import { getMetricsDateRange } from "@/sales-tools/leaderboard/utils/getMetricsDateRange";
import { ChecklistSummary } from "@/sales-tools/metrics/checklist-summary/ChecklistSummary";
import { PerformanceMetrics } from "@/sales-tools/metrics/components/PerformanceMetrics";
import { TrophyCaseCard } from "@/sales-tools/metrics/components/TrophyCaseCard";

interface StatsDrawerProps {
    opened: boolean;
    onClose: () => void;
    showChecklistSummary: boolean;
    showTrophyCase: boolean;
}

export function StatsDrawer({ opened, onClose, showChecklistSummary, showTrophyCase }: StatsDrawerProps) {
    return (
        <Drawer
            opened={opened}
            withinPortal={false}
            onClose={onClose}
            withCloseButton={false}
            transitionProps={{
                duration: 0,
            }}
            withOverlay={false}
            styles={{
                content: {
                    backgroundColor: "#14171C",
                    position: "absolute",
                    top: 53,
                },
                body: {
                    padding: 0,
                },
            }}
        >
            <Stack w="39.5rem" p="md" styles={{ root: { overflow: "auto" } }}>
                <Stack pos="absolute" right="0.2rem" top=".1rem">
                    <CloseButton variant="transparent" ml="auto" onClick={onClose} />
                </Stack>

                <Stack w="100%">
                    <Flex justify="space-between" mt="sm">
                        <Text size="xs">Week of {getMetricsDateRange()}</Text>
                    </Flex>
                    <PerformanceMetrics />
                    <Stack w="24.438rem" pos="absolute" right="0.875rem" top="1.85rem" gap="1.25rem">
                        <Text size="xxs" c="dark.2" ta="right">
                            Heads up&mdash;this data is not official and might not represent final metrics.
                        </Text>
                        {showChecklistSummary && <ChecklistSummary />}
                        {showTrophyCase && <TrophyCaseCard />}
                    </Stack>
                </Stack>
            </Stack>
        </Drawer>
    );
}
